import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { hideModal } from '../../../../../../redux/actions'
import ModalContainer from '../../../../../Modals/ModalContainer'
import { Box } from '@mui/system'

function ArchiveEventModal({
    eventIds,
    onClickSubmit,
}) {
    const dispatch = useDispatch()
    const [processing, setProcessing] = useState(false)

    const getModalText = () => {
        return (
            <>
                <Box>
                    {`Are you sure you want to archive ${eventIds.length === 1 ? 'the event' : 'these events'}? Any GOVX ID links deployed for ${eventIds.length === 1 ? 'this event' : 'these events'} will no longer be accessible.`}
                </Box>
                <Box mt={2} fontWeight="bold">
                    {`This action cannot be undone.`}
                </Box>
            </>
        )
    }

    return (
        <ModalContainer
            title={`Archive Event${eventIds?.length === 1 ? '' : 's'}`}
            maxWidth="sm"
            fullWidth="true"
            hideModal={() => { }}
            processing={processing}
            actions={{
                primaryAction: {
                    label: 'Archive',
                    onClick: async () => {
                        setProcessing(true)

                        try {
                            await onClickSubmit(eventIds)
                        } finally {
                            setProcessing(false)
                        }
                    },
                },
                secondaryAction: { label: 'Cancel', onClick: () => dispatch(hideModal()) },
            }}
        >
            <Box>{getModalText()}</Box>
        </ModalContainer>
    )

}

export default ArchiveEventModal    